import _isEmpty from "lodash/isEmpty";
import _cloneDeep from "lodash/cloneDeep";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "flex": "1",
    "position": "relative"
  }
};
const _hoisted_2 = {
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "right": "0",
    "bottom": "0",
    "margin-top": "10px"
  }
};
const _hoisted_3 = {
  class: "input-with-select el-input el-input-group"
};
const _hoisted_4 = {
  key: 0,
  class: "el-input-group__append"
};
import * as api from '../../api/code-gen';
import * as CODE_GEN from '../../constant/code-gen';
import * as CodeGenHelper from '../../util/codegen-helper';
import { toast } from '@/utils/message';
import { Setting } from '@element-plus/icons-vue';
import storage from '@/utils/storage';
import { XTable } from '@/components/index';

import { ref, reactive, computed, watch, onMounted } from 'vue';
const TABLE_CACHE_PREFIX = 'dev:codegen:table-prop:';
export default /*@__PURE__*/_defineComponent({
  __name: 'TableProp',
  props: {
    tableName: {
      default: ''
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const tableRef = ref();
    const props = __props;
    const table = ref({
      loading: false,
      data: [],
      action: {
        query: false,
        table: false,
        create: false,
        update: false,
        export: false
      },
      business: null,
      showCommonProp: false
    });
    const options = reactive({
      propType: CODE_GEN.SELECT_OPTIONS.PROP_TYPE,
      uiComponent: CODE_GEN.SELECT_OPTIONS.UI_COMPONENT,
      matchMethod: CODE_GEN.SELECT_OPTIONS.MATCH_METHOD
    });
    const tableCacheName = computed(() => `${TABLE_CACHE_PREFIX}${props.tableName}`);
    watch(() => props.tableName, () => {
      clearTable();
      performQuery();
    });
    watch(() => table.value.showCommonProp, val => {
      if (val) {
        return;
      }
      const data = table.value.data;
      if (!data || data.length < 1) {
        return;
      }
      // 如果隐藏了公共属性 则将公共属性的所有操作禁用
      for (const item of data) {
        if (item.common && item.actions) {
          for (const ac of Object.values(item.actions)) {
            ac.enable = false;
          }
        }
      }
    });
    onMounted(() => {
      performQuery();
    });
    function handleActionToggle(action, toggle) {
      updateActionSelection(action, toggle);
    }
    function handleRefresh() {
      clearTableCache();
      performQuery();
    }
    function performQuery() {
      if (table.value.loading || !props.tableName) {
        return;
      }
      startLoading();
      if (hasTableCache()) {
        table.value = getTableCache();
        stopLoading();
      } else {
        api.getBusiness(props.tableName).then(result => {
          table.value.business = _cloneDeep(result.data);
          const props = result.data.properties;
          prepareProps(props);
          table.value.data = props;
        }).finally(() => {
          stopLoading();
        });
      }
    }
    function prepareProps(propArr) {
      if (propArr && propArr.length > 0) {
        for (const prop of propArr) {
          prepareAction(prop);
          prepareUiComponent(prop);
          deduceCommonProp(prop);
        }
      }
    }
    function prepareUiComponent(prop) {
      if (!prop.uiComponent) {
        prop.uiComponent = {
          name: CODE_GEN.UI_COMPONENTS.INPUT.name
        };
      }
      if (!prop.uiComponent.attributes) {
        prop.uiComponent.attributes = {};
      }
    }
    function prepareAction(prop) {
      if (!prop.actions) {
        const actions = {};
        actions[CODE_GEN.ACTIONS.QUERY] = {
          enable: false,
          name: CODE_GEN.ACTIONS.QUERY,
          config: {}
        };
        actions[CODE_GEN.ACTIONS.TABLE] = {
          enable: false,
          name: CODE_GEN.ACTIONS.TABLE,
          config: {}
        };
        actions[CODE_GEN.ACTIONS.CREATE] = {
          enable: false,
          name: CODE_GEN.ACTIONS.CREATE,
          config: {}
        };
        actions[CODE_GEN.ACTIONS.UPDATE] = {
          enable: false,
          name: CODE_GEN.ACTIONS.UPDATE,
          config: {}
        };
        actions[CODE_GEN.ACTIONS.EXPORT] = {
          enable: false,
          name: CODE_GEN.ACTIONS.EXPORT,
          config: {}
        };
        actions[CODE_GEN.ACTIONS.IMPORT] = {
          enable: false,
          name: CODE_GEN.ACTIONS.IMPORT,
          config: {}
        };
        prop.actions = actions;
      } else {
        for (const action of Object.values(prop.actions)) {
          action.enable = false;
          if (!action.config) {
            action.config = {};
          }
        }
      }
    }
    function deduceCommonProp(prop) {
      prop.common = CODE_GEN.COMMON_COLUMNS.includes(prop.columnName.toLowerCase());
    }
    function deduceRowStyle({
      row
    }) {
      if (!row.common) {
        return {};
      }
      if (table.value.showCommonProp) {
        return {};
      } else {
        return {
          display: 'none'
        };
      }
    }
    function updateActionSelection(action, selection) {
      const data = table.value.data;
      if (!data || data.length < 1) {
        return;
      }
      for (const item of data) {
        // 如果是公共属性且不显示公共属性则不更新选择状态
        if (item.common && !table.value.showCommonProp) {
          continue;
        }
        const actions = item.actions;
        if (actions && actions[action]) {
          actions[action].enable = selection;
        }
      }
    }
    function clearTable() {
      table.value.business = null;
      table.value.data = [];
    }
    function startLoading() {
      table.value.loading = true;
    }
    function stopLoading() {
      table.value.loading = false;
    }
    function getBusiness() {
      if (table.value.data.length < 1) {
        return;
      }
      if (!table.value.business || table.value.loading) {
        toast.warn('属性未加载完毕');
        return;
      }
      for (const prop of table.value.data) {
        if (_isEmpty(prop.propName)) {
          toast.warn(`请输入字段${prop.columnName}对应的属性名称`);
          return;
        }
        if (_isEmpty(prop.propComment)) {
          toast.warn(`请输入字段${prop.columnName}对应的属性描述`);
          return;
        }
      }
      const business = _cloneDeep(table.value.business);
      const props = _cloneDeep(table.value.data);
      pruneActions(props);
      representComponent(props);
      business.properties = props;
      setTableCache(table.value);
      return business;
    }
    function pruneActions(properties) {
      if (_isEmpty(properties)) {
        return;
      }
      for (const prop of properties) {
        if (!prop.actions) {
          continue;
        }
        // 删除未启用的操作
        for (const k of Object.keys(prop.actions)) {
          if (!prop.actions[k].enable) {
            delete prop.actions[k];
          }
        }
      }
    }
    function representComponent(properties) {
      if (_isEmpty(properties)) {
        return;
      }
      for (const prop of properties) {
        const comp = prop.uiComponent;
        if (comp) {
          comp.represent = CODE_GEN.getComponentByName(comp.name)?.represent;
          if (!comp.attributes) {
            comp.attributes = {};
          }
          if (comp.attributes.dictCode) {
            comp.attributes['dict-code'] = comp.attributes.dictCode;
            delete comp.attributes.dictCode;
          }
          Object.assign(comp.attributes, CodeGenHelper.deduceComponentAttrs(prop));
        }
      }
    }
    function clearTableCache() {
      storage.remove(tableCacheName.value);
    }
    function hasTableCache() {
      return storage.has(tableCacheName.value);
    }
    function getTableCache() {
      return storage.get(tableCacheName.value);
    }
    function setTableCache(tb) {
      storage.set(tableCacheName.value, tb);
    }
    __expose({
      getBusiness
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_input = _resolveComponent("el-input");
      const _component_x_select = _resolveComponent("x-select");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_link = _resolveComponent("el-link");
      const _component_XAppLayout = _resolveComponent("XAppLayout");
      const _directive_loading = _resolveDirective("loading");
      return _ctx.tableName ? (_openBlock(), _createBlock(_component_XAppLayout, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: handleRefresh
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("刷新")])),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 2,
            offset: 18
          }, {
            default: _withCtx(() => [_createVNode(_component_el_checkbox, {
              modelValue: _unref(table).showCommonProp,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(table).showCommonProp = $event),
              label: "显示公共属性",
              border: "",
              size: "small"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(XTable), {
          ref_key: "tableRef",
          ref: tableRef,
          data: _unref(table).data,
          "show-index": "",
          "el-table-props": {
            rowStyle: deduceRowStyle
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "字段名称",
            prop: "columnName",
            "min-width": "120",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            label: "字段类型",
            prop: "columnType",
            "min-width": "120",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            label: "字段描述",
            prop: "columnComment",
            "min-width": "120",
            align: "center",
            "show-tooltip-when-overflow": ""
          }), _createVNode(_component_el_table_column, {
            label: "实体定义",
            align: "center"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "属性名称",
              prop: "propName",
              "min-width": "120",
              align: "center"
            }, {
              default: _withCtx(({
                row
              }) => [_createVNode(_component_el_input, {
                modelValue: row.propName,
                "onUpdate:modelValue": $event => row.propName = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "属性类型",
              prop: "propType",
              "min-width": "120",
              align: "center"
            }, {
              default: _withCtx(({
                row
              }) => [_createVNode(_component_x_select, {
                modelValue: row.propType,
                "onUpdate:modelValue": $event => row.propType = $event,
                options: _unref(options).propType
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "属性描述",
              prop: "propComment",
              "min-width": "120",
              align: "center"
            }, {
              default: _withCtx(({
                row
              }) => [_createVNode(_component_el_input, {
                modelValue: row.propComment,
                "onUpdate:modelValue": $event => row.propComment = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "UI组件",
            "min-width": "140",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_x_select, {
              modelValue: row.uiComponent.name,
              "onUpdate:modelValue": $event => row.uiComponent.name = $event,
              class: "select",
              options: _unref(options).uiComponent
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]), row.uiComponent.name === 'select' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_popover, {
              placement: "left",
              width: "100"
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, {
                icon: _unref(Setting)
              }, null, 8, ["icon"])]),
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: row.uiComponent.attributes.dictCode,
                "onUpdate:modelValue": $event => row.uiComponent.attributes.dictCode = $event,
                placeholder: "关联字典代码"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1024)])) : _createCommentVNode("", true)])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "功能",
            align: "center"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "查询",
              width: "80",
              align: "center"
            }, {
              header: _withCtx(() => [_createVNode(_component_el_checkbox, {
                modelValue: _unref(table).action.query,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(table).action.query = $event),
                onChange: _cache[2] || (_cache[2] = $event => handleActionToggle('query', _unref(table).action.query))
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("查询")])),
                _: 1
              }, 8, ["modelValue"])]),
              default: _withCtx(({
                row
              }) => [_createVNode(_component_el_checkbox, {
                modelValue: row.actions.query.enable,
                "onUpdate:modelValue": $event => row.actions.query.enable = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "列表",
              width: "80",
              align: "center"
            }, {
              header: _withCtx(() => [_createVNode(_component_el_checkbox, {
                modelValue: _unref(table).action.table,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(table).action.table = $event),
                onChange: _cache[4] || (_cache[4] = $event => handleActionToggle('table', _unref(table).action.table))
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("列表")])),
                _: 1
              }, 8, ["modelValue"])]),
              default: _withCtx(({
                row
              }) => [_createVNode(_component_el_checkbox, {
                modelValue: row.actions.table.enable,
                "onUpdate:modelValue": $event => row.actions.table.enable = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "新增",
              width: "80",
              align: "center"
            }, {
              header: _withCtx(() => [_createVNode(_component_el_checkbox, {
                modelValue: _unref(table).action.create,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(table).action.create = $event),
                onChange: _cache[6] || (_cache[6] = $event => handleActionToggle('create', _unref(table).action.create))
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("新增")])),
                _: 1
              }, 8, ["modelValue"])]),
              default: _withCtx(({
                row
              }) => [_createVNode(_component_el_checkbox, {
                modelValue: row.actions.create.enable,
                "onUpdate:modelValue": $event => row.actions.create.enable = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "修改",
              width: "80",
              align: "center"
            }, {
              header: _withCtx(() => [_createVNode(_component_el_checkbox, {
                modelValue: _unref(table).action.update,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(table).action.update = $event),
                onChange: _cache[8] || (_cache[8] = $event => handleActionToggle('update', _unref(table).action.update))
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("修改")])),
                _: 1
              }, 8, ["modelValue"])]),
              default: _withCtx(({
                row
              }) => [_createVNode(_component_el_checkbox, {
                modelValue: row.actions.update.enable,
                "onUpdate:modelValue": $event => row.actions.update.enable = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "导入/导出",
              width: "120",
              align: "center"
            }, {
              header: _withCtx(() => [_createVNode(_component_el_checkbox, {
                modelValue: _unref(table).action.export,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(table).action.export = $event),
                onChange: _cache[10] || (_cache[10] = $event => handleActionToggle('export', _unref(table).action.export))
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("导入/导出")])),
                _: 1
              }, 8, ["modelValue"])]),
              default: _withCtx(({
                row
              }) => [_createVNode(_component_el_checkbox, {
                modelValue: row.actions.export.enable,
                "onUpdate:modelValue": $event => row.actions.export.enable = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "操作",
              width: "100",
              align: "center"
            }, {
              default: _withCtx(({
                row
              }) => [_createVNode(_component_el_popover, {
                placement: "left",
                title: `配置 - ${row.propComment}`,
                width: "280",
                trigger: "click"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_divider, null, {
                  default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                    modelValue: row.actions.query.enable,
                    "onUpdate:modelValue": $event => row.actions.query.enable = $event
                  }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("查询")])),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])]),
                  _: 2
                }, 1024), _createVNode(_component_el_form, {
                  disabled: !row.actions.query.enable,
                  inline: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "是否必填"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_switch, {
                      modelValue: row.actions.query.config.required,
                      "onUpdate:modelValue": $event => row.actions.query.config.required = $event
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                    _: 2
                  }, 1024), _createVNode(_component_el_form_item, {
                    label: "匹配方法"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_x_select, {
                      modelValue: row.actions.query.config.match_method,
                      "onUpdate:modelValue": $event => row.actions.query.config.match_method = $event,
                      style: {
                        "width": "120px"
                      },
                      options: _unref(options).matchMethod
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1032, ["disabled"]), _createVNode(_component_el_divider, null, {
                  default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                    modelValue: row.actions.table.enable,
                    "onUpdate:modelValue": $event => row.actions.table.enable = $event
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("列表")])),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])]),
                  _: 2
                }, 1024), _createVNode(_component_el_form, {
                  disabled: !row.actions.table.enable,
                  inline: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "支持排序"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_switch, {
                      modelValue: row.actions.table.config.sortable,
                      "onUpdate:modelValue": $event => row.actions.table.config.sortable = $event
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1032, ["disabled"]), _createVNode(_component_el_divider, null, {
                  default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                    modelValue: row.actions.create.enable,
                    "onUpdate:modelValue": $event => row.actions.create.enable = $event
                  }, {
                    default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("新增")])),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])]),
                  _: 2
                }, 1024), _createVNode(_component_el_form, {
                  disabled: !row.actions.create.enable,
                  inline: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "是否必填"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_switch, {
                      modelValue: row.actions.create.config.required,
                      "onUpdate:modelValue": $event => row.actions.create.config.required = $event
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1032, ["disabled"]), _createVNode(_component_el_divider, null, {
                  default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                    modelValue: row.actions.update.enable,
                    "onUpdate:modelValue": $event => row.actions.update.enable = $event
                  }, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("修改")])),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])]),
                  _: 2
                }, 1024), _createVNode(_component_el_form, {
                  disabled: !row.actions.update.enable,
                  inline: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "是否必填"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_switch, {
                      modelValue: row.actions.update.config.required,
                      "onUpdate:modelValue": $event => row.actions.update.config.required = $event
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1032, ["disabled"])]),
                reference: _withCtx(() => [_createVNode(_component_el_link, {
                  type: "primary",
                  icon: _unref(Setting)
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode("配置")])),
                  _: 1
                }, 8, ["icon"])]),
                _: 2
              }, 1032, ["title"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "el-table-props"])])), [[_directive_loading, _unref(table).loading]])])]),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});